/* Símaveski wishlist — localStorage based, no app, works for guests. */
(function () {
  if (window.__simaWishlist) return;
  window.__simaWishlist = true;

  var KEY = 'simaveski_wishlist';

  function get() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function save(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
  }
  function toggle(d) {
    var a = get();
    var i = -1, k;
    for (k = 0; k < a.length; k++) { if (a[k].handle === d.handle) { i = k; break; } }
    if (i > -1) { a.splice(i, 1); } else { a.unshift(d); }
    save(a);
    return i === -1; // true if it was added
  }
  function remove(handle) {
    save(get().filter(function (x) { return x.handle !== handle; }));
  }

  function updateCount() {
    var n = get().length;
    document.querySelectorAll('.js-wishlist-count').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }
  function markHearts() {
    var items = get();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = items.some(function (i) { return i.handle === btn.dataset.handle; });
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function renderPage() {
    var root = document.getElementById('wishlist-root');
    if (!root) return;
    var items = get();
    var empty = document.getElementById('wishlist-empty');
    if (!items.length) {
      root.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';
    root.innerHTML = items.map(function (i) {
      var img = i.image ? '<img src="' + i.image + '" alt="' + (i.title || '') + '" loading="lazy">' : '';
      return '<div class="wl-card">'
        + '<button class="wl-remove" data-wishlist-remove data-handle="' + i.handle + '" aria-label="Fjarlægja af óskalista">&times;</button>'
        + '<a class="wl-card__img" href="' + i.url + '">' + img + '</a>'
        + '<a class="wl-card__title" href="' + i.url + '">' + (i.title || '') + '</a>'
        + (i.price ? '<div class="wl-card__price">' + i.price + '</div>' : '')
        + '<a class="wl-card__btn" href="' + i.url + '">Skoða vöru</a>'
        + '</div>';
    }).join('');
  }
  function refresh() { updateCount(); markHearts(); renderPage(); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-wishlist-toggle]');
    if (t) {
      e.preventDefault(); e.stopPropagation();
      toggle({
        handle: t.dataset.handle, title: t.dataset.title, url: t.dataset.url,
        image: t.dataset.image, price: t.dataset.price
      });
      refresh();
      return;
    }
    var r = e.target.closest('[data-wishlist-remove]');
    if (r) { e.preventDefault(); remove(r.dataset.handle); refresh(); }
  });

  if (document.readyState !== 'loading') refresh();
  else document.addEventListener('DOMContentLoaded', refresh);
  window.addEventListener('pageshow', refresh);
})();
